export const ru = {
    copied: 'Скопировано',
    'copy-error': 'Ошибка при копировании',
    'copy-link': 'Копировать условия в буфер обмена',
    'open-popup-text': 'Посмотреть условия',
    'popup-title': 'Условия ретаргетинга'
};
